import { useRef } from "react";
import { DisplayMode, useFilterStore } from "~/components/build/Show/lib/useFilterStore";
import { StepTree as SidebarStepTree } from "~/components/build/Show/components/Sidebar/StepTree";
import { useTreeNodes as useSidebarTreeNodes } from "~/components/build/Show/components/Sidebar/useTreeNodes";
import { Table } from "~/components/build/Show/routes/table";
import { ListView } from "~/components/build/Show/routes/list";

/** @deprecated Use `ListView` instead. */
const SidebarMobileStepsView = () => {
  const displayMode = DisplayMode.Pipeline;
  const filters = useFilterStore((state) => state.filterBy);
  const scrollRef = useRef<HTMLDivElement>(null);
  const { isLoading, nodes } = useSidebarTreeNodes({ displayMode, filters });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (Features.HideBuildSidebar) {
    return (
      <div className="relative h-full w-full flex-auto">
        <Table className="absolute" />
      </div>
    );
  }

  return (
    <div className="absolute h-full w-full overflow-auto" ref={scrollRef}>
      <SidebarStepTree nodes={nodes} displayMode={displayMode} scrollRef={scrollRef} />
    </div>
  );
};

export const MobileStepsView = () => {
  if (Features.BuildPageListView) {
    return <ListView />;
  }

  return <SidebarMobileStepsView />;
};
